import React from 'react'
import { useDispatch } from "react-redux";
import EditModal from "../common/EditModal";
import { updateCourse } from '../../redux/actions/admin/courseAction';

const EditCourse = ({id, name, fees, desc, startDate, endDate, refreshData}) => {
  const dispatch = useDispatch();
    const formFields = [
      {
        name: "name",
        label: "Course Name",
        value: name,
        placeholder: "Course Name",
      },
      {
        name: "fees",
        label: "Course Fees",
        value: fees,
        placeholder: "Course Fees",
      },
      
      {
        name: "desc",
        label: "Course Description",
        value: desc,
        placeholder: "Course Description",
        type: "description"
      },

      {
        name: "startDate",
        label: "Course Start Date",
        value: startDate,
        placeholder: "Course Start Date",
        type: "date"
      },

      {
        name: "endDate",
        label: "Course End Date",
        value: endDate,
        placeholder: "Course End Date",
        type: "date"
      },
    ];
  
    // Handle the course data update
    const handleUpdate = async (courseData) => {
      await dispatch(updateCourse(id, courseData));
      refreshData();
    };
  return (
    <>
    <EditModal
        title="Edit Course Details"
        formFields={formFields}
        onSubmit={handleUpdate}
        buttonName="Update Course"
        modelTitle="Are you sure you want to edit these Course details?"
        content="Please confirm to apply the changes mode to this course."
        okText="Yes, Change"
        cancelText="No, Cancel"
      />
    </>
  ) 
}

export default EditCourse